import { useAddBranchControlToWorkFlow } from './useAddBranchControlToWorkFlow';
import { useOnBranchControlDragged } from './useOnBranchControlDragged';
import { useHideDropNodes } from './useHideDropNodes';

export const useBranchControl = () => {
  const addToFlow = useAddBranchControlToWorkFlow();
  const onBranchControlDragged = useOnBranchControlDragged();
  const hideDropNodes = useHideDropNodes();

  return {
    addToFlow,
    onBranchControlDragged,
    hideDropNodes,
  };
};
